import React, { useEffect, useState, useCallback } from 'react';

import SemantixLogo from 'assets/images/semantix-logo.png';

import { logout, getProfile } from 'services/auth';
import NavBarLink from './NavBarLink';
import NavBarButton from './NavBarButton';

import NavLinks from './navLinks';

import * as S from './styles';

const NavBar = () => {
  const [accessIds, setAcessIds] = useState();

  const [backgroundVisibility, setBackgroundVisibility] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  const [hasSubmenu, setHasSubmenu] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [submenuList, setSubmenuList] = useState([]);

  const handleMenuOpen = type => {
    if (type === 'menu') {
      return [
        setBackgroundVisibility(currentState => !currentState),
        setIsMenuOpen(currentState => !currentState),
      ];
    }

    return [
      setBackgroundVisibility(currentState => !currentState),
      setSubmenuOpen(currentState => !currentState),
    ];
  };

  const handleWindowEvent = useCallback(event => {
    const screen = event.currentTarget.visualViewport.width;

    if (screen <= 768) return setIsMenuOpen(false);

    return setIsMenuOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleWindowEvent);

    if (window.innerWidth <= 768) setIsMenuOpen(false);

    return () => window.removeEventListener('resize', handleWindowEvent);
  }, [handleWindowEvent]);

  useEffect(() => {
    (async () => {
      const profile = await getProfile();
      const { acessos } = JSON.parse(profile);
      setAcessIds(acessos || undefined);
    })();
  }, []);

  return (
    <>
      <S.OpenHideNav
        isMenuOpen={isMenuOpen}
        onClick={() => handleMenuOpen('menu')}
      >
        <div />
      </S.OpenHideNav>
      <S.BackgroundArea
        onClick={() => {
          setSubmenuOpen(false);
          setBackgroundVisibility(false);
        }}
        isVisible={backgroundVisibility}
      />

      <S.SubmenuContainer isVisible={submenuOpen}>
        <S.SubmenuItems>
          {submenuList.map(({ text, redirectTo, hasAccess }) => {
            const hasRouteAccess =
              hasAccess.filter(id => accessIds.includes(id)).length > 0;

            return (
              hasRouteAccess && (
                <S.RedirectTo
                  onClick={() => handleMenuOpen('submenu')}
                  to={redirectTo}
                >
                  {text}
                </S.RedirectTo>
              )
            );
          })}
        </S.SubmenuItems>
      </S.SubmenuContainer>

      <S.NavContainer isOpen={isMenuOpen}>
        <S.NavLogo src={SemantixLogo} alt="Semantix Logotipo" />
        <S.NavItemsContainer>
          {accessIds && (
            <S.NavItems>
              {NavLinks.map((nav, index) => {
                const { hasAccess, path, name, icon, submenuItems } = nav;

                const hasRouteAccess =
                  hasAccess.filter(id => accessIds.includes(id)).length > 0;

                return hasRouteAccess && !!path ? (
                  <NavBarLink path={path} text={name} key={index.toString()}>
                    {icon(name.toLowerCase())}
                  </NavBarLink>
                ) : hasRouteAccess ? (
                  <NavBarButton
                    text={name}
                    key={index.toString()}
                    hasSubmenu={hasSubmenu}
                    setHasSubmenu={setHasSubmenu}
                    handleMenuOpen={handleMenuOpen}
                    setSubmenuList={setSubmenuList}
                    submenuItems={submenuItems}
                    setSubmenuOpen={setSubmenuOpen}
                  >
                    {icon(name.toLowerCase())}
                  </NavBarButton>
                ) : (
                  <></>
                );
              })}
            </S.NavItems>
          )}
        </S.NavItemsContainer>
        <S.Logout onClick={() => logout()}>
          <NavBarLink path={window.location.origin} text="Sair">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
            >
              <path
                d="M34.3148 15.516C34.3791 15.3607 34.3791 15.1857 34.3148 15.0298C34.2824 14.9515 34.2353 14.8809 34.1767 14.8217L26.541 7.18661C26.2922 6.9378 25.89 6.9378 25.6412 7.18661C25.3924 7.43543 25.3924 7.83761 25.6412 8.08643L32.1913 14.6365H18.4547C18.1028 14.6365 17.8184 14.921 17.8184 15.2729C17.8184 15.6248 18.1028 15.9093 18.4547 15.9093H32.1913L25.6412 22.4593C25.3924 22.7082 25.3924 23.1103 25.6412 23.3592C25.7653 23.4833 25.9282 23.5456 26.0911 23.5456C26.254 23.5456 26.4169 23.4833 26.541 23.3592L34.1767 15.7234C34.2353 15.6649 34.2824 15.5943 34.3148 15.516Z"
                fill="#4A4A4A"
              />
              <path
                d="M22.9094 18.4545C22.5575 18.4545 22.2731 18.739 22.2731 19.0909V29.2727H15.9094V5.09091C15.9094 4.81345 15.73 4.56845 15.4659 4.48445L5.3719 1.27273H22.2731V11.4545C22.2731 11.8065 22.5575 12.0909 22.9094 12.0909C23.2614 12.0909 23.5458 11.8065 23.5458 11.4545V0.636364C23.5458 0.284455 23.2614 0 22.9094 0H1.27308C1.25272 0 1.2349 0.00954545 1.21517 0.0114545C1.17954 0.0146364 1.14836 0.0229091 1.11463 0.0318182C1.05481 0.0477273 1.00136 0.0693636 0.94981 0.100545C0.933264 0.110727 0.913537 0.110727 0.897628 0.122182C0.877901 0.136818 0.862628 0.155273 0.84481 0.171182C0.833991 0.181364 0.822537 0.190273 0.812355 0.201091C0.763991 0.253273 0.724537 0.311182 0.695264 0.374818C0.689537 0.387545 0.686355 0.400273 0.681264 0.413C0.654537 0.484273 0.636719 0.558727 0.636719 0.636364V29.9091C0.636719 29.9886 0.655173 30.0637 0.682537 30.135C0.691446 30.1585 0.70481 30.1783 0.716264 30.2005C0.73981 30.2457 0.766537 30.2871 0.800264 30.3253C0.818719 30.3456 0.837173 30.3641 0.857537 30.3825C0.894446 30.415 0.93581 30.4417 0.980355 30.4653C1.0039 30.478 1.02554 30.4914 1.05099 30.5009C1.06181 30.5047 1.07008 30.5124 1.0809 30.5162L15.0809 34.9707C15.1433 34.9898 15.2082 35 15.2731 35C15.4067 35 15.5384 34.958 15.6485 34.8778C15.8127 34.7582 15.9094 34.5673 15.9094 34.3636V30.5455H22.9094C23.2614 30.5455 23.5458 30.261 23.5458 29.9091V19.0909C23.5458 18.739 23.2607 18.4545 22.9094 18.4545ZM14.6367 33.4937L1.90945 29.4439V1.50627L14.6367 5.55609V33.4937Z"
                fill="#4A4A4A"
              />
            </svg>
          </NavBarLink>
        </S.Logout>
      </S.NavContainer>
    </>
  );
};

export default NavBar;
